<section class="titulo">
    <p>
        <br><br>
    </p>
    <div class="titleImagen">
        <p style="line-height: 100%;" class="fontMS700 font-45 colorPrincipal">
            EL RETRATO<br> FOTOGRÁFICO
            <br> EN LIMA<br>
            <span class="fontMS300">(1860-1930)</span><br>
        </p>
        <div id="sharePic">
            <a (click)="test.toggle()" mdbWavesEffect>
                <img width="200px" src="/assets/images/general/MP_BOTON_COMPARTIR.jpg">
            </a>
            <div mdbCollapse #test="bs-collapse">
                <div class="divShared">
                    &nbsp; &nbsp;
                    <a target="_blank" href="http://www.facebook.com/sharer.php?u=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio3/retrato-foto">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_FB.png">
                    </a>&nbsp;
                    <a target="_blank" href="https://api.whatsapp.com/send?text=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio3/retrato-foto">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_INST.png">
                    </a>&nbsp;
                    <a target="_blank" href="https://twitter.com/intent/tweet?text=MemoriaPeru&url=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio3/retrato-foto">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_TW.png">
                    </a>
                </div>
            </div>
        </div>
    </div>
    <img width="100%" src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_img001.jpg">
</section>

<div class="fondoBlanco_Intro">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-6">
                        <p class="fontMS500 font-24">
                            POCO TIEMPO DESPUÉS DE SU INVENCIÓN EN EUROPA, LA FOTOGRAFÍA DESEMBARCA EN EL PERÚ HACIA 1842 COMO DAGUERROTIPO. 
                            SU PRÁCTICA COMERCIAL Y ARTÍSTICA SE DA EN UN PERIODO DE IMPORTANTES CAMBIOS SOCIALES, POLÍTICOS, CULTURALES Y ESTÉTICOS.
                        </p>
                        <p class="text-center">
                            <ngx-slick-carousel class="carousel" #slickModal="slick-carousel" [config]="slideConfig2">
                                <div ngxSlickItem class="slide p-2">
                                    <div class="divLibros text-center w-100">
                                        <a href="https://hdl.handle.net/20.500.14428/54647" target="_blank" style="color: black;">
                                            <p class="text-center">
                                                <img width="100%" src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_img002a.jpg">
                                            </p>
                                        </a>
                                    </div>
                                </div>
                                <div ngxSlickItem class="slide p-2">
                                    <div class="divLibros text-center w-100">
                                        <a href="https://hdl.handle.net/20.500.14428/36917" target="_blank" style="color: black;">
                                            <p class="text-center">
                                                <br><br><br><br><br><br><br><br>
                                                <img width="100%" src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_img002b.jpg">
                                            </p>
                                        </a>
                                    </div>
                                </div>
                            </ngx-slick-carousel>
                        </p>
                    </div>
                    <div class="col-sm-6">
                        <p class="font-24 text-gris p2">
                            La fotografía es la última etapa de una serie de procedimientos técnicos y fotoquímicos. Es un soporte para la imagen 
                            y también es una fuente documental que preserva la memoria individual y colectiva, por lo cual, es clave para la 
                            configuración de la identidad de las personas y las colectividades.

                            <br><br> 
                            
                            La Biblioteca Nacional del Perú conserva una extraordinaria colección de retratos fotográficos realizados en el Estudio 
                            E. Courret a lo largo de setenta años.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoAzulODis">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-3">
                        <img class="LineSubsec" width="100%" src="\assets\images\micrositio\micrositio3\ET02_MS03_FOT__LINEA1-recortada2.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 130%;margin-bottom: 0%;" class="fontMS700 text-center colorPrincipal font-40">
                            EL ESTUDIO CENTRAL <br>
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec bottom_cel" width="100%" src="\assets\images\micrositio\micrositio3\ET02_MS03_FOT__LINEA1-recortada2.png">
                    </div>
                </div>
                <p style="line-height: 100%;margin-top: 0%;margin-bottom: 0%;" class="fontMS500 text-center colorPrincipal font-40">
                    COURRET Y DUBREUIL
                </p>
                <div class="c100">
                    <img class="lineCel" width="100%" src="\assets\images\micrositio\micrositio3\ET02_MS03_FOT__LINEA1-recortada2.png">
                </div>
                <p class="font-24 fontMS500 text-center text-white">
                    <br> HACIA 1863, EN UNA LIMA DE CIEN MIL HABITANTES, LOS FRANCESES EUGÈNE<br> Y ACHILLE COURRET FUNDAN EL ESTUDIO “FOTOGRAFÍA CENTRAL”,<br> OFRECIENDO LOS SERVICIOS DE RETRATOS, REPRODUCCIONES DE PINTURAS, <br> TARJETAS POSTALES, ÁLBUMES
                    Y TODO TIPO DE MATERIALES RELACIONADOS<br> A ESE NOVEDOSO INVENTO LLAMADO LA FOTOGRAFÍA.
                </p>
                <p class="fontMS100 font-24 text-justify text-white">
                    <br> En 1873, Achille Courret deja el estudio, el cual cambia de nombre a “E. Courret”. Personajes del poder político, económico y religioso posan ante su lente, así como familias citadinas que muestran sus costumbres para vestir, para celebrar 
                    algún acontecimiento familiar o social, e incluso frente a la muerte. En 1881, Eugène Courret logra fotografiar los balnearios de Chorrillos y Miraflores saqueados e incendiados por el ejército chileno durante la Guerra del Pacífico. En 1892, 
                    se transfiere el negocio a Adolphe Dubreuil, aunque la firma sigue figurando como “E. Courret y Cía.”. Dubreuil continúa manteniendo la calidad de sus retratos de estudio, y del mismo modo, los diferentes estratos de la sociedad siguen desfilando 
                    frente a su cámara en busca de perennizarse. En 1905 se inaugura la fachada  <span class="fontMS100Italic">art
                        nouveau</span> del estudio, que se conserva hasta hoy en jirón De la Unión en el Centro de Lima. En 1920, René Dubreuil, hijo de Adolphe, asume la dirección del taller registrando las nuevas conductas y formas de época en sus modelos hasta el 
                        cierre del estudio en 1935.
                    <br><br> Un acontecimiento importante, fue la incorporación del artista Teófilo Castillo (1857-1922), quien tenía un prestigio pictórico consolidado en Europa. Luego de su labor en el estudio fotográfico Witcomb de Buenos Aires, el artista regresa 
                    a Lima en 1906 y es requerido por Adolphe Dubreuil para ocupar el puesto de director artístico del estudio en reemplazo del pintor y fotógrafo Luis S. Ugarte. Esta alianza incrementará grandemente la reputación del estudio. Durante este periodo de 
                    labor en dicho cargo, hasta 1908, Castillo trabajó entre óleos y fotografías.

                    <br><br><br>
                </p>
                <!--CEL-->
                <div class="row menuWebPhone">
                    <div class="col-sm-4">
                        <div class="libro">
                            <a href="https://hdl.handle.net/20.500.14428/55433" target="_blank" style="color: black;">
                                <img class="img-fluid imgNP" width="100%" src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_img003a.jpg">
                                <div class="overlay">
                                    <p class="fontMS500 text-center">
                                        Eugène Courret, 1886 <br>
                                    </p>
                                </div>
                            </a>
                            <br> <br>
                        </div>
                        <div class="libro">
                            <a href="https://hdl.handle.net/20.500.14428/50864" target="_blank" style="color: black;">
                                <img class="img-fluid imgNP" width="100%" src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_img003b.jpg">
                                <div class="overlay">
                                    <p class="fontMS500 text-center">
                                        Francisco Graña Reyes, 1880
                                    </p>
                                </div>
                            </a>
                            <br><br>
                        </div>
                        <div class="libro">
                            <a href="https://hdl.handle.net/20.500.14428/78280" target="_blank" style="color: black;">
                                <img class="img-fluid imgNP" width="100%" src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_img003i.jpg">
                                <div class="overlay">
                                    <p class="fontMS500 text-center">
                                        Eloyda Garland Roel, 1907
                                    </p>
                                </div>
                            </a>
                            <br><br>
                        </div>
                    </div>
                    <div class="col-sm-4">
                        <div class="libro">
                            <a href="https://hdl.handle.net/20.500.14428/65999" target="_blank" style="color: black;">
                                <img class="img-fluid imgNP_sp" width="100%" src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_img003e.jpg">
                                <div class="overlay5">
                                    <p class="fontMS500 text-center">
                                        Adolphe Dubreuil, 1882 <br>
                                    </p>
                                </div>
                            </a>
                            <br> <br>
                        </div>
                        <div class="libro">
                            <a href="https://hdl.handle.net/20.500.14428/3320" target="_blank" style="color: black;">
                                <img class="img-fluid imgNP" width="100%" src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_img003c.jpg">
                                <div class="overlay">
                                    <p class="fontMS500 text-center">
                                        Ting Coh, 1884 <br>
                                    </p>
                                </div>
                            </a>
                            <br> <br>
                        </div>
                        <div class="libro">
                            <a href="https://hdl.handle.net/20.500.14428/30279" target="_blank" style="color: black;">
                                <img class="img-fluid imgNP" width="100%" src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_img003h.jpg">
                                <div class="overlay">
                                    <p class="fontMS500 text-center">
                                        Gerardo Alarco Larraburre, Ca. 1912
                                    </p>
                                </div>
                            </a>
                            <br> <br>
                        </div>
                    </div>
                    <div class="col-sm-4">
                        <div class="libro">
                            <a href="https://hdl.handle.net/20.500.14428/78296" target="_blank" style="color: black;">
                                <img class="img-fluid imgNP" width="100%" src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_img003d.jpg">
                                <div class="overlay">
                                    <p class="fontMS500 text-center">
                                        René Dubreuil, 1909 <br>
                                    </p>
                                </div>
                            </a>
                            <br> <br>
                        </div>
                        <div class="libro">
                            <a href="https://hdl.handle.net/20.500.14428/48726" target="_blank" style="color: black;">
                                <img class="img-fluid imgNP" width="100%" src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_img003g.jpg">
                                <div class="overlay">
                                    <p class="fontMS500 text-center">
                                        Geraldo Arosemena Garland, 1904
                                    </p>
                                </div>
                            </a>
                            <br><br>
                        </div>
                        <div class="libro">
                            <a href="https://hdl.handle.net/20.500.14428/30280" target="_blank" style="color: black;">
                                <img class="img-fluid imgNP" width="100%" src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_img003f.jpg">
                                <div class="overlay">
                                    <p class="fontMS500 text-center">
                                        Rosa Alarco Larrabure, Ca. 1912
                                    </p>
                                </div>
                            </a>
                            <br><br>
                        </div>
                    </div>
                </div>

                <!--TABLET-->
                <div class="row menuTablet">
                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 libro t3">
                            <a href="https://hdl.handle.net/20.500.14428/55433" target="_blank" style="color: black;">
                                <img class="img-fluid imgNP" width="100%" src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_img003a.jpg">
                                <div class="overlay">
                                    <p class="fontMS500 text-center">
                                        Eugène Courret, 1886 <br>
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="col-sm-6 libro t3">
                            <a href="https://hdl.handle.net/20.500.14428/50864" target="_blank" style="color: black;">
                                <img class="img-fluid imgNP" width="100%" src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_img003b.jpg">
                                <div class="overlay">
                                    <p class="fontMS500 text-center">
                                        Francisco Graña Reyes, 1880
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 libro t3">
                            <a href="https://hdl.handle.net/20.500.14428/78280" target="_blank" style="color: black;">
                                <img class="img-fluid imgNP" width="100%" src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_img003i.jpg">
                                <div class="overlay">
                                    <p class="fontMS500 text-center">
                                        Eloyda Garland Roel, 1907
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="col-sm-6 libro t3">
                            <a href="https://hdl.handle.net/20.500.14428/65999" target="_blank" style="color: black;">
                                <img class="img-fluid imgNP_sp" width="100%" src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_img003e.jpg">
                                <div class="overlay5">
                                    <p class="fontMS500 text-center">
                                        Adolphe Dubreuil, 1882 <br>
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 libro t3">
                            <a href="https://hdl.handle.net/20.500.14428/3320" target="_blank" style="color: black;">
                                <img class="img-fluid imgNP" width="100%" src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_img003c.jpg">
                                <div class="overlay">
                                    <p class="fontMS500 text-center">
                                        Ting Coh, 1884 <br>
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="col-sm-6 libro t3">
                            <a href="https://hdl.handle.net/20.500.14428/30279" target="_blank" style="color: black;">
                                <img class="img-fluid imgNP" width="100%" src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_img003h.jpg">
                                <div class="overlay">
                                    <p class="fontMS500 text-center">
                                        Gerardo Alarco Larraburre, Ca. 1912
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 libro t3">
                            <a href="https://hdl.handle.net/20.500.14428/78296" target="_blank" style="color: black;">
                                <img class="img-fluid imgNP" width="100%" src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_img003d.jpg">
                                <div class="overlay">
                                    <p class="fontMS500 text-center">
                                        René Dubreuil, 1909 <br>
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="col-sm-6 libro t3">
                            <a href="https://hdl.handle.net/20.500.14428/48726" target="_blank" style="color: black;">
                                <img class="img-fluid imgNP" width="100%" src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_img003g.jpg">
                                <div class="overlay">
                                    <p class="fontMS500 text-center">
                                        Geraldo Arosemena Garland, 1904
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 libro t3">
                            <a href="https://hdl.handle.net/20.500.14428/30280" target="_blank" style="color: black;">
                                <img class="img-fluid imgNP" width="100%" src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_img003f.jpg">
                                <div class="overlay">
                                    <p class="fontMS500 text-center">
                                        Rosa Alarco Larrabure, Ca. 1912
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="col-sm-6 libro t3">
                            <br>
                        </div>
                    </div>
                </div>
                <p>
                    <br><br>
                    <img width="100%" src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT__LINEA2.jpg">
                    <br><br>
                </p>
                <div class="row">
                    <div class="col-sm-4">
                        <p style="line-height: 170%;margin-bottom: 0%;" class="fontMS700 colorPrincipal font-40">
                            <br> EN EL ESTUDIO
                        </p>
                    </div>
                    <div class="col-sm-8">
                        <img class="LineSubsec bottom_cel" width="100%" src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT__LINEA1-recortada2.png">
                    </div>
                </div>
                <p style="line-height: 120%;" class="fontMS300 colorPrincipal font-40">
                    LECCIÓN VISUAL EN UNA FOTO:<br> FONDO, LUZ, ENCUADRE, POSE
                </p>
                <div class="c100">
                    <img class="lineCel" width="100%" src="\assets\images\micrositio\micrositio3\ET02_MS03_FOT__LINEA1-recortada2.png">
                </div>
                <p class="font-24 text-white fontMS300 bottom_cel">
                    <br> DURANTE LA SEGUNDA MITAD DEL SIGLO XIX, <br> LOS PROCESOS FOTOGRÁFICOS EVOLUCIONAN Y <br> LOS ESTUDIOS INSTALADOS EN LIMA RÁPIDAMENTE <br> INCORPORAN LAS NUEVAS TÉCNICAS.<br><br>
                </p>
                <div class="c100">
                    <p class="font-24 text-white fontMS300">
                        <br> DURANTE LA SEGUNDA MITAD DEL SIGLO XIX, LOS PROCESOS FOTOGRÁFICOS EVOLUCIONAN Y LOS ESTUDIOS INSTALADOS EN LIMA RÁPIDAMENTE INCORPORAN LAS NUEVAS TÉCNICAS.
                    </p>
                </div>
                <div class="row">
                    <div class="col-sm-6 bottom_cel">
                        <div class="row"><br><br><br><br><br><br></div>
                        <div class="row">
                            <div class="libro">
                                <a href="https://hdl.handle.net/20.500.14428/64068" target="_blank" style="color: black;">
                                    <img class="img-fluid imgNP" width="80%" src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_img004a.jpg">
                                    <div class="overlay7">
                                        <p class="fontMS500 text-center">
                                            Sr. Saint Genys, 1885 <br>
                                        </p>
                                    </div>
                                </a>
                                <br> <br>
                            </div>
                            <p class="fontMS100Italic font-18 text-grisC p3 t_img">
                                <span>1. Equipo reflector de la luz</span><br>
                                <span class="text-white">2. Luz ingresada por las teatinas del estudio</span><br>
                                <span>3. Operario que sostiene el telón de fondo</span><br>
                                <span>4. Telón o escenografía</span><br>
                                <span>5. Sombra producto de la luz natural</span><br>
                                <span>6. Fotógrafo y cámara fotográfica</span><br>
                            </p>
                        </div>
                    </div>
                    <div class="c100">
                        <div class="libro">
                            <a href="https://hdl.handle.net/20.500.14428/64068" target="_blank" style="color: black;">
                                <img class="img-fluid imgNP" width="100%" src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_img004a.jpg">
                                <div class="overlay7">
                                    <p class="fontMS500 text-center">
                                        Sr. Saint Genys, 1885 <br>
                                    </p>
                                </div>
                            </a>
                        </div>
                        <p class="fontMS100Italic font-18 text-grisC p3 t_img">
                            <span>1. Equipo reflector de la luz</span><br>
                            <span class="text-white">2. Luz ingresada por las teatinas del estudio</span><br>
                            <span>3. Operario que sostiene el telón de fondo</span><br>
                            <span>4. Telón o escenografía</span><br>
                            <span>5. Sombra producto de la luz natural</span><br>
                            <span>6. Fotógrafo y cámara fotográfica</span><br>
                        </p>
                    </div>
                    <div class="col-sm-6">
                        <p class="fontMS100 text-white font-24">
                            Los Courret utilizaron los negativos al colodión, sustancia que permite una rápida “captura” de la imagen pero que requiere un tratamiento 
                            inmediato del negativo para evitar su pérdida. Cuando se realiza un trabajo en exteriores es obligatorio llevar un laboratorio transportable 
                            para el proceso de fijado de la imagen en las placas de vidrio. Posteriormente, se sustituye por los procesos en gelatina de plata, más estables 
                            que no requieren un fijado inmediato de la placa de vidrio, lo que permite al fotógrafo más libertad. Eugène Courret trabajó gran parte del tiempo 
                            aprovechando la luz natural y dependiendo de la estación; y tuvo una mayor planificación en el uso de teatinas, ventanas y paneles en el estudio. 
                            Adolphe y René Dubreuil, desde finales del s. XIX, hacen uso de otro invento: la luz eléctrica. Esta permite una nueva dimensión en el trabajo
                            artístico del uso de luces y sombras en los retratos.
                        </p>
                    </div>
                </div>
                <p>
                    <img class="info" width="100%" src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_INFO.png">
                    <br><br><br>
                </p>
                <div class="row Img_AmBottom">
                    <div class="col-sm-4 libro">
                        <a href="https://hdl.handle.net/20.500.14428/78297" target="_blank" style="color: black;">
                            <img class="img-fluid bot" src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_img004b.jpg">
                            <div class="overlay2">
                                <p class="fontMS500">
                                    Ramón Menéndez Pidal, 1905
                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-4 libro">
                        <a href="https://hdl.handle.net/20.500.14428/44219" target="_blank" style="color: black;">
                            <img class="img-fluid bot" src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_img004c.jpg">
                            <div class="overlay2">
                                <p class="fontMS500">
                                    Ramón Menéndez Pidal, 1905
                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-4 libro">
                        <a href="https://hdl.handle.net/20.500.14428/53551" target="_blank" style="color: black;">
                            <img class="img-fluid bot" src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_img004d.jpg">
                            <div class="overlay2">
                                <p class="fontMS500">
                                    Ramón Menéndez Pidal, 1905
                                </p>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="fondoGris_Q">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <br><br><br><br><br><br><br>
                <img src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA_RESALTE.png" width="100%">
                <p class="fontMS500 text-justify font-24">
                    <br> EUGÈNE COURRET ESTARÁ ASOCIADO A LA HISTORIA DE LA FOTOGRAFÍA DEL PERÚ. INMIGRANTE, EMPRESARIO, ARTISTA, SU LEGADO RECORRE LA ABRUPTA TRAYECTORIA DEL PERÚ DE MITAD DEL SIGLO XIX: LA BONANZA DEL GUANO, LA BANCARROTA, LA GUERRA
                    Y LA CRISIS.
                    <br>
                </p>
                <div class="text-right">
                    <p class="fontMS500Italic font-24">
                        ISABELLE TAUZIN-CASTELLANOS, 2019.<br>
                    </p>
                </div>
                <img src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA_RESALTE.png" class="reflejo" width="100%">
            </div>
        </div>
    </div>
</div>
<div class="fondoBlancoDesing">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-3">
                        <img class="LineSubsec" width="100%" src="\assets\images\micrositio\micrositio3\ET02_MS03_FOT__LINEA1-recortada2.png">
                    </div>
                    <div class="col-sm-6 text-center">
                        <p style="line-height: 130%; padding-bottom: 0%; margin-bottom: 0%;" class="fontMS700 text-center colorPrincipal font-40">
                            EL RETRATO FOTOGRÁFICO
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec bottom_cel" width="100%" src="\assets\images\micrositio\micrositio3\ET02_MS03_FOT__LINEA1-recortada2.png">
                    </div>
                </div>
                <p style="line-height: 130%; margin-top: 0%;padding-top: 0%;margin-bottom: 0%;" class="fontMS300 colorPrincipal text-center font-40">
                    COMO DOCUMENTO
                    <br> Y AFIRMACIÓN SOCIAL
                </p>
                <div class="c100">
                    <img class="lineCel" width="100%" src="\assets\images\micrositio\micrositio3\ET02_MS03_FOT__LINEA1-recortada2.png">
                </div>
                <div class="row t5">
                    <div class="col-sm-6">
                        <div class="libro">
                            <a href="https://hdl.handle.net/20.500.14428/64408" target="_blank" style="color: black;">
                                <img class="imgNP2 img-fluid" width="70%" src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_img005a.jpg">
                                <div class="overlay6">
                                    <p class="fontMS500">
                                        Familia Alarco, ca. 1890
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <p class=" fontMS500 font-24">
                            EL RETRATO PINTADO ESTABA ASIGNADO A LA ARISTOCRACIA QUE PODÍA SOLVENTARLO. ESTA CONDICIÓN CAMBIÓ EN EL SIGLO XIX CON EL RETRATO 
                            FOTOGRÁFICO QUE INICIA LA REPRESENTACIÓN DE OTRO SECTOR SOCIAL: LA BURGUESÍA. POR PRIMERA VEZ EN LA HISTORIA, POLÍTICOS, MILITARES, 
                            INTELECTUALES, ABOGADOS Y COMERCIANTES, CONSTRUYERON UNA IDENTIDAD VISUAL, UN DOCUMENTO DE SUS CONDICIONES SOCIALES Y ECONÓMICAS.

                        </p>
                    </div>
                </div>
                <p class="text-justify font-24 text-gris p2">
                    Los estudios fotográficos en Lima de la segunda mitad del siglo XIX son negocios comerciales, en los que el prestigio del maestro fotógrafo se sustenta: 
                    tener un espacio adecuado donde se pudiera controlar la luz, contar con escenografía y tener ayudantes entrenados para los procesos de preparación de placas 
                    y revelado.
                    <br><br> El retrato fotográfico se transformó en un objeto inherente y habitual de la vida cotidiana. El acto de retratarse fue el resultado de la tendencia 
                    de perennizar los sucesos más importantes de las vidas de las personas como, por ejemplo, la primera comunión, la graduación, el matrimonio, un viaje o incluso 
                    la llegada de la muerte. Otra característica de los retratos fotográficos es que fue una adaptación al discurso construido, una estandarización idealizada a 
                    través de posturas y gestos, del vestuario que representaba una función social, y de escenografías con telones y fondos, sillones, alfombras o cualquier otro 
                    complemento.
                    <br><br>Los retratos que conforman el extenso archivo de la colección Courret, no solo perennizaron individuos, sino que documentan el imaginario colectivo de 
                    la sociedad limeña del centenario, sus valores y la transformación de las relaciones y roles sociales que construyeron.
                    <br><br>
                </p>
                <div class="row menuWebPhone">
                    <div class="col-sm-3">
                        <div class="libro">
                            <a href="https://hdl.handle.net/20.500.14428/36312" target="_blank" style="color: black;">
                                <img class="img-fluid" src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_img005b.jpg" width="100%">
                                <div class="overlay3">
                                    <p class="fontMS500">
                                        ¿E. Maunoury? El Congreso Americano de Lima, 1864
                                    </p>
                                </div>
                            </a>
                        </div>
                        <br>
                        <div class="libro">
                            <a href="https://hdl.handle.net/20.500.14428/3646" target="_blank" style="color: black;">
                                <img class="img-fluid" src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_img005j.jpg" width="100%">
                                <div class="overlay3">
                                    <p class="fontMS500">
                                        Celebraciones religiosas: matrimonio Novios y familia: Santiago Bisset, 1883
                                    </p>
                                </div>
                            </a>
                        </div>
                        <br>
                        <div class="libro">
                            <a href="https://hdl.handle.net/20.500.14428/54532" target="_blank" style="color: black;">
                                <img class="img-fluid" src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_img005k.jpg" width="100%">
                                <div class="overlay3">
                                    <p class="fontMS500">
                                        Ismael Monzón y novia, 1896
                                    </p>
                                </div>
                            </a>
                        </div>
                        <br>
                        <div class="libro">
                            <a href="https://hdl.handle.net/20.500.14428/54642" target="_blank" style="color: black;">
                                <img class="img-fluid" src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_img005i.jpg" width="100%">
                                <div class="overlay3">
                                    <p class="fontMS500">
                                        Adolfo Dubreuil. El militar: Roque Sáenz Peña, 1905
                                    </p>
                                </div>
                            </a>
                        </div>
                        <br>
                    </div>
                    <div class="col-sm-3">
                        <div class="libro">
                            <a href="https://hdl.handle.net/20.500.14428/62153" target="_blank" style="color: black;">
                                <img class="img-fluid" src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_img005o.jpg" width="100%">
                                <div class="overlay3">
                                    <p class="fontMS500">
                                        Retrato post mortem: Henry Meiggs, 1877
                                    </p>
                                </div>
                            </a>
                        </div>
                        <br>
                        <div class="libro">
                            <a href="https://hdl.handle.net/20.500.14428/63024" target="_blank" style="color: black;">
                                <img class="img-fluid" src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_img005c.jpg" width="100%">
                                <div class="overlay3">
                                    <p class="fontMS500">
                                        Empresarios: Jacobo Backus y Howard Johnston, 1890
                                    </p>
                                </div>
                            </a>
                        </div>
                        <br>
                        <div class="libro">
                            <a href="https://hdl.handle.net/20.500.14428/30537" target="_blank" style="color: black;">
                                <img class="img-fluid" src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_img005m.jpg" width="100%">
                                <div class="overlay3">
                                    <p class="fontMS500">
                                        Primera comunión: Isabel Benavides, 1896
                                    </p>
                                </div>
                            </a>
                        </div>
                        <br>
                        <div class="libro">
                            <a href="https://hdl.handle.net/20.500.14428/29322" target="_blank" style="color: black;">
                                <img class="img-fluid" src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_img005f.jpg" width="100%">
                                <div class="overlay3">
                                    <p class="fontMS500">
                                        Adolescente vehemente: María Luisa Garland Higginson, 1906
                                    </p>
                                </div>
                            </a>
                        </div>
                        <br>
                    </div>
                    <div class="col-sm-3 ">
                        <div class="libro">
                            <a href="https://hdl.handle.net/20.500.14428/7965" target="_blank" style="color: black;">
                                <img class="img-fluid" src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_img005h.jpg" width="100%">
                                <div class="overlay3">
                                    <p class="fontMS500">
                                        Los voluntarios de la guerra: Manuel Ayala y la Cruz Roja Peruana, 1881
                                    </p>
                                </div>
                            </a>
                        </div>
                        <br>
                        <div class="libro">
                            <a href="https://hdl.handle.net/20.500.14428/53903" target="_blank" style="color: black;">
                                <img class="img-fluid" src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_img005d.jpg" width="100%">
                                <div class="overlay3">
                                    <p class="fontMS500">
                                        Intelectuales: Federico Villareal, 1890
                                    </p>
                                </div>
                            </a>
                        </div>
                        <br>
                        <div class="libro">
                            <a href="https://hdl.handle.net/20.500.14428/55403" target="_blank" style="color: black;">
                                <img class="img-fluid" src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_img005p.jpg" width="100%">
                                <div class="overlay3">
                                    <p class="fontMS500">
                                        Adolfo Dubreuil. Retrato post mortem: Niño, 1896
                                    </p>
                                </div>
                            </a>
                        </div>
                        <br>
                        <div class="libro">
                            <a href="https://hdl.handle.net/20.500.14428/55444" target="_blank" style="color: black;">
                                <img class="img-fluid" src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_img005n.jpg" width="100%">
                                <div class="overlay3">
                                    <p class="fontMS500">
                                        Escenificación de época en el Palacio Torre Tagle, 1917
                                    </p>
                                </div>
                            </a>
                        </div>
                        <br>
                    </div>
                    <div class="col-sm-3 ">
                        <div class="libro">
                            <a href="https://hdl.handle.net/20.500.14428/20440" target="_blank" style="color: black;">
                                <img class="img-fluid" src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_img005g.jpg" width="100%">
                                <div class="overlay3">
                                    <p class="fontMS500">
                                        Los voluntarios de la guerra: el señor Marimón y la Cruz Roja peruana, 1881
                                    </p>
                                </div>
                            </a>
                        </div>
                        <br>
                        <div class="libro">
                            <a href="https://hdl.handle.net/20.500.14428/26072" target="_blank" style="color: black;">
                                <img class="img-fluid" src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_img005q.jpg" width="100%">
                                <div class="overlay3">
                                    <p class="fontMS500">
                                        Adolfo Dubreuil. Retrato post mortem: Niño, 1896
                                    </p>
                                </div>
                            </a>
                        </div>
                        <br>
                        <div class="libro">
                            <a href="https://hdl.handle.net/20.500.14428/72311" target="_blank" style="color: black;">
                                <img class="img-fluid" src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_img005e.jpg" width="100%">
                                <div class="overlay3">
                                    <p class="fontMS500">
                                        Adolfo Dubreuil. Manuel González Prada, 1902
                                    </p>
                                </div>
                            </a>
                        </div>
                        <br>
                        <div class="libro">
                            <a href="https://hdl.handle.net/20.500.14428/40491" target="_blank" style="color: black;">
                                <img class="img-fluid" src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_img005l.jpg" width="100%">
                                <div class="overlay3">
                                    <p class="fontMS500">
                                        René Dubreuil. Boda Núñez, ca. 1930
                                    </p>
                                </div>
                            </a>
                        </div>
                        <br>
                    </div>
                </div>
                <!--TABLET-->
                <div class="row menuTablet">
                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 libro t3">
                            <a href="https://hdl.handle.net/20.500.14428/36312" target="_blank" style="color: black;">
                                <img class="img-fluid" src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_img005b.jpg" width="100%">
                                <div class="overlay3">
                                    <p class="fontMS500">
                                        ¿E. Maunoury? El Congreso Americano de Lima, 1864
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="col-sm-6 libro t3">
                            <a href="https://hdl.handle.net/20.500.14428/3646" target="_blank" style="color: black;">
                                <img class="img-fluid" src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_img005j.jpg" width="100%">
                                <div class="overlay3">
                                    <p class="fontMS500">
                                        Celebraciones religiosas: matrimonio Novios y familia: Santiago Bisset, 1883
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 libro t3">
                            <a href="https://hdl.handle.net/20.500.14428/54532" target="_blank" style="color: black;">
                                <img class="img-fluid" src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_img005k.jpg" width="100%">
                                <div class="overlay3">
                                    <p class="fontMS500">
                                        Ismael Monzón y novia, 1896
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="col-sm-6 libro t3">
                            <a href="https://hdl.handle.net/20.500.14428/54642" target="_blank" style="color: black;">
                                <img class="img-fluid" src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_img005i.jpg" width="100%">
                                <div class="overlay3">
                                    <p class="fontMS500">
                                        Adolfo Dubreuil. El militar: Roque Sáenz Peña, 1905
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 libro t3">
                            <a href="https://hdl.handle.net/20.500.14428/62153" target="_blank" style="color: black;">
                                <img class="img-fluid" src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_img005o.jpg" width="100%">
                                <div class="overlay3">
                                    <p class="fontMS500">
                                        Retrato post mortem: Henry Meiggs, 1877
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="col-sm-6 libro t3">
                            <a href="https://hdl.handle.net/20.500.14428/63024" target="_blank" style="color: black;">
                                <img class="img-fluid" src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_img005c.jpg" width="100%">
                                <div class="overlay3">
                                    <p class="fontMS500">
                                        Empresarios: Jacobo Backus y Howard Johnston, 1890
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 libro t3">
                            <a href="https://hdl.handle.net/20.500.14428/30537" target="_blank" style="color: black;">
                                <img class="img-fluid" src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_img005m.jpg" width="100%">
                                <div class="overlay3">
                                    <p class="fontMS500">
                                        Primera comunión: Isabel Benavides, 1896
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="col-sm-6 libro t3">
                            <a href="https://hdl.handle.net/20.500.14428/29322" target="_blank" style="color: black;">
                                <img class="img-fluid" src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_img005f.jpg" width="100%">
                                <div class="overlay3">
                                    <p class="fontMS500">
                                        Adolescente vehemente: María Luisa Garland Higginson, 1906
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 libro t3">
                            <a href="https://hdl.handle.net/20.500.14428/7965" target="_blank" style="color: black;">
                                <img class="img-fluid" src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_img005h.jpg" width="100%">
                                <div class="overlay3">
                                    <p class="fontMS500">
                                        Los voluntarios de la guerra: Manuel Ayala y la Cruz Roja Peruana, 1881
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="col-sm-6 libro t3">
                            <a href="https://hdl.handle.net/20.500.14428/26072" target="_blank" style="color: black;">
                                <img class="img-fluid" src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_img005d.jpg" width="100%">
                                <div class="overlay3">
                                    <p class="fontMS500">
                                        Intelectuales: Federico Villareal, 1890
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 libro t3">
                            <a href="https://hdl.handle.net/20.500.14428/55403" target="_blank" style="color: black;">
                                <img class="img-fluid" src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_img005p.jpg" width="100%">
                                <div class="overlay3">
                                    <p class="fontMS500">
                                        Adolfo Dubreuil. Retrato post mortem: Niño, 1896
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="col-sm-6 libro t3">
                            <a href="https://hdl.handle.net/20.500.14428/55444" target="_blank" style="color: black;">
                                <img class="img-fluid" src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_img005n.jpg" width="100%">
                                <div class="overlay3">
                                    <p class="fontMS500">
                                        Escenificación de época en el Palacio Torre Tagle, 1917
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 libro t3">
                            <a href="https://hdl.handle.net/20.500.14428/20440" target="_blank" style="color: black;">
                                <img class="img-fluid" src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_img005g.jpg" width="100%">
                                <div class="overlay3">
                                    <p class="fontMS500">
                                        Los voluntarios de la guerra: el señor Marimón y la Cruz Roja peruana, 1881
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="col-sm-6 libro t3">
                            <a href="https://hdl.handle.net/20.500.14428/26072" target="_blank" style="color: black;">
                                <img class="img-fluid" src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_img005q.jpg" width="100%">
                                <div class="overlay3">
                                    <p class="fontMS500">
                                        Adolfo Dubreuil. Retrato post mortem: Niño, 1896
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="row mt-3 mb-3">
                            <div class="col-sm-6 libro t3">
                                <a href="https://hdl.handle.net/20.500.14428/72311" target="_blank" style="color: black;">
                                    <img class="img-fluid" src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_img005e.jpg" width="100%">
                                    <div class="overlay3">
                                        <p class="fontMS500">
                                            Adolfo Dubreuil. Manuel González Prada, 1902
                                        </p>
                                    </div>
                                </a>
                            </div>
                            <div class="col-sm-6 libro t3">
                                <a href="https://hdl.handle.net/20.500.14428/40491" target="_blank" style="color: black;">
                                    <img class="img-fluid" src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_img005l.jpg" width="100%">
                                    <div class="overlay3">
                                        <p class="fontMS500">
                                            René Dubreuil. Boda Núñez, ca. 1930
                                        </p>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="fondoGris">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-6">
                        <p style="line-height: 160%;margin-bottom: 0%;" class="fontMS700 colorPrincipal font-38">
                            CONSTRUCCIÓN DE UN LINAJE
                        </p>
                    </div>
                    <div class="col-sm-6">
                        <img class="LineSubsec_Izq" width="100%" src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT__LINEA1-recortada2.png">
                    </div>
                </div>
                <p class="fontMS500 font-24">
                    <br> LA COLECCIÓN COURRET ES UN PODEROSO TESTIMONIO VISUAL PARA COMPRENDER LA SOCIEDAD DEL SIGLO XIX, PUESTO QUE DOCUMENTA LA CONFORMACIÓN DE CIERTA 
                    ÉLITE LIMEÑA, SUS VÍNCULOS Y ALIANZAS Y SU CONSOLIDACIÓN ECONÓMICA Y POLÍTICA. UN EJEMPLO DE LA MOVILIDAD SOCIAL ES LA PRESENTACIÓN DE LOS RETRATOS DE 
                    LA FAMILIA GARLAND A TRAVÉS DE TRES GENERACIONES A LO LARGO DE CINCUENTA AÑOS.
                    <br><br>
                </p>
                <div class="row">
                    <div class="col-sm-6">
                        <p class="font-24 text-gris">
                            El origen de la familia Garland se remonta al norte de Inglaterra. El primer Garland que inmigra al Perú fue Gerald Garland Myers (1811-1898) en la 
                            década de 1830. Se dedicó a la contabilidad en la Casa Gibbs, empresa que tenía el monopolio de las ventas del guano. Contrajo matrimonio con la joven 
                            Enriqueta von Lotten y Sierra (1826-1896), hijastra del negociante alemán Henry Witt. Su descendencia se extiende y ramifica por otros linajes familiares, 
                            uniéndose con otros apellidos notables, nacionales y extranjeros, que resaltaban por ser parte de los ámbitos económico, político, social y cultural dominantes 
                            de Lima. Entre las familias con las que se unió la familia Garland están los Prado, los Graña y los Miró Quesada.
                            <br><br>
                            La identificación de los integrantes Garland dentro del archivo Courret se realizó comparando fechas y relacionando personajes con las limitadas inscripciones 
                            encontradas en las placas de vidrio. Los retratos anteriores a 1892 corresponden a Eugène Courret y las posteriores a Adolphe y René Dubreuil.

                        </p>
                    </div>
                    <div class="col-sm-6 libro">
                        <a href="https://hdl.handle.net/20.500.14428/77678" target="_blank" style="color: black;">
                            <img class="img-fluid" src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_img006k_nueva.jpg" width="100%">
                            <div class="overlay4">
                                <p class="fontMS500 text-center">
                                    Enriqueta von Lotten y Sierra de Garland <br> 1880.
                                </p>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-12">
                <p>
                    <br>
                </p>
                <div style="width:100%;margin:0;">
                    <div class="linea bottom_cel">&nbsp;&nbsp;</div>
                    <div class="linea c100">&nbsp;&nbsp;</div>
                    <div class="leyenda fontMS500 font-24">PRIMERA GENERACIÓN FAMILIA GARLAND</div>
                    <div class="linea bottom_cel">&nbsp;&nbsp;</div>
                    <div class="linea c100">&nbsp;&nbsp;</div>
                    <br><br><br>
                </div>
                <p>
                    <br>
                </p>
            </div>
        </div>
        <ngx-slick-carousel class="carousel" #slickModal="slick-carousel" [config]="slideConfig">
            <div ngxSlickItem *ngFor="let slide of slides" class="slide p-2">
                <div class="divLibros text-center w-100">
                    <!-- <a style="color: inherit;" [routerLink]="['/visor',slide.id]" target="_blank"> -->
                    <a style="color: inherit;" href="{{slide.id}}" target="_blank">
                        <p class="text-center">
                            <img src="{{ slide.img }}" alt="" width="100%">
                        </p>
                        <div class="divNombresLibros">
                            <p class="text-center">
                                <span>{{slide.autor}}</span><br>
                                <span>{{slide.anno}}</span>
                            </p>
                        </div>
                    </a>
                </div>
            </div>
        </ngx-slick-carousel>

        <div class="row">
            <div class="col-sm-12">
                <p>
                    <br>
                </p>
                <div style="width:100%;">
                    <div class="linea2 bottom_cel">&nbsp;</div>
                    <div class="linea2 c100">&nbsp;</div>
                    <div class="leyenda fontMS500 font-24">SEGUNDA GENERACIÓN FAMILIA GARLAND</div>
                    <div class="linea2 bottom_cel">&nbsp;</div>
                    <div class="linea2 c100">&nbsp;</div>
                    <br><br><br>
                </div>
                <p>
                    <br>
                </p>
            </div>
        </div>
        <ngx-slick-carousel class="carousel" #slickModal="slick-carousel" [config]="slideConfig">
            <div ngxSlickItem *ngFor="let slide of slides2" class="slide p-2">
                <div class="divLibros text-center w-100">
                    <!-- <a style="color: inherit;" [routerLink]="['/visor',slide.id]" target="_blank"> -->
                    <a style="color: inherit;" href="{{slide.id}}" target="_blank">
                        <p class="text-center">
                            <img src="{{ slide.img }}" alt="" width="100%">
                        </p>
                        <div class="divNombresLibros">
                            <p class="text-center">
                                <span>{{slide.autor}}</span><br>
                                <span>{{slide.anno}}</span>
                            </p>
                        </div>
                    </a>
                </div>
            </div>
        </ngx-slick-carousel>

        <div class="row">
            <div class="col-sm-12">
                <p>
                    <br>
                </p>
                <div style="width:100%;">
                    <div class="linea bottom_cel">&nbsp;</div>
                    <div class="linea c100">&nbsp;</div>
                    <div class="leyenda fontMS500 font-22">TERCERA GENERACIÓN FAMILIA GARLAND</div>
                    <div class="linea bottom_cel">&nbsp;</div>
                    <div class="linea c100">&nbsp;</div>
                    <br><br><br>
                </div>
                <p>
                    <br>
                </p>
                <ngx-slick-carousel class="carousel" #slickModal="slick-carousel" [config]="slideConfig3">
                    <div ngxSlickItem *ngFor="let slide of slides3" class="slide p-2">
                        <div class="divLibros text-center w-100 mb-3">
                            <p class="text-center">
                                <img src="{{ slide.img }}" alt="" width="100%">
                            </p>
                            <div class="divNombresLibros">
                                <p class="text-center">
                                    <span>{{slide.autor}}</span><br>
                                    <span>{{slide.anno}}</span>
                                </p>
                            </div>
                        </div>
                    </div>
                </ngx-slick-carousel>
            </div>
        </div>
    </div>
</div>

<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <p class="fontMS700 font-40">
                    <span class="colorPrincipal">
                        ¿Por qué se deteriora<br>
                        el soporte?
                    </span>
                </p>
                <div class="row">
                    <div class="col-sm-3">
                    </div>
                    <div class="col-sm-9">
                        <p class="font-24 text-gris">
                            <br> Una causa del deterioro de los soportes en vidrio está en los mismos procesos empleados para la fijación de las imágenes en las placas: 
                            el colodión es más sensible al cambio de temperatura y humedad, ya que estos factores pueden producir el desprendimiento de las emulsiones. 
                            Además, en otros casos, el proceso químico seguido para revelar los negativos puede producir con el tiempo la pérdida de la imagen por desvanecimiento.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="fondoAzulODis2">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-3">
                        <img class="LineSubsec" width="100%" src="\assets\images\micrositio\micrositio3\ET02_MS03_FOT__LINEA1-recortada2.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 130%;margin-bottom: 0%;padding-bottom: 0%;" class="fontMS700 text-center colorPrincipal font-40">
                            SUJETO Y PODER
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec bottom_cel" width="100%" src="\assets\images\micrositio\micrositio3\ET02_MS03_FOT__LINEA1-recortada2.png">
                    </div>
                </div>
                <p style="line-height: 100%;margin-top: 0%;padding-top: 0%;" class="fontMS300 text-center colorPrincipal font-40 bottom_cel">
                    PRESIDENTE Y ALCALDE DE LA <br>REPÚBLICA ARISTOCRÁTICA<br><br>
                </p>
                <p style="line-height: 100%;margin-top: 0%;padding-top: 0%;margin-bottom: 2%;" class="fontMS300 text-center colorPrincipal font-40 c100">
                    PRESIDENTE Y ALCALDE DE LA REPÚBLICA ARISTOCRÁTICA
                </p>
                <div class="c100">
                    <img class="lineCel" width="100%" src="\assets\images\micrositio\micrositio3\ET02_MS03_FOT__LINEA1-recortada2.png">
                </div>
                <p class="fontMS500 text-white text-justify font-24">
                    <br> UNA SELECCIÓN EN EL ARCHIVO COURRET PERMITIÓ REALIZAR UN PARALELO CRONOLÓGICO VISUAL ENTRE JOSÉ PARDO Y BARREDA (1864-1947) Y FEDERICO ELGUERA 
                    SEMINARIO (1860-1928), PERSONAJES DE RELEVANCIA HISTÓRICA Y POLÍTICA DE INICIOS DEL SIGLO XX. CONTEMPORÁNEOS, ABOGADOS, ADSCRITOS AL PARTIDO CIVIL, 
                    GOBERNARON EN PARALELO COMO PRESIDENTE (1904-1908) Y ALCALDE DE LIMA (1901-1908), RESPECTIVAMENTE.
                </p>
                <p class="fontMS100 text-white text-justify font-24">
                    <br> Elegidos durante la República Aristocrática (1899-1919), llamada así por el historiador Jorge Basadre, porque era una democracia limitada, 
                    gobernada por las clases altas, y con un proyecto de desarrollo con escasa intervención de las clases medias y populares. José Pardo, como presidente, 
                    afrontó problemas limítrofes, impulsó la industria naviera y ferroviaria e hizo obligatoria la educación primaria. En tanto, Federico Elguera, 
                    como alcalde de Lima, condujo la expansión urbana de la ciudad, junto a obras de saneamiento y ornato.
                    <br><br>
                    Los retratos fotográficos de dichos personajes también señalaron la sucesión en el estudio Courret, pues las imágenes posteriores a 1892 corresponden a 
                    Adolphe Dubreuil, quien se hizo cargo del estudio luego de la partida de Eugène Courret a Francia.
                    <br><br>
                </p>
                <div class="row menuWebPhone">
                    <div class="col-sm-3">
                        <div class="libro">
                            <a href="https://hdl.handle.net/20.500.14428/16072" target="_blank" style="color: black;">
                                <img src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_img007a.jpg" width="100%">
                                <div class="overlay3">
                                    <p class="fontMS500 text-center">
                                        José Pardo y Barreda <br> 1887
                                    </p>
                                </div>
                            </a>
                        </div>
                        <br>
                        <div class="libro">
                            <a href="https://hdl.handle.net/20.500.14428/77952" target="_blank" style="color: black;">
                                <img src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_img007e.jpg" width="100%">
                                <div class="overlay3">
                                    <p class="fontMS500 text-center">
                                        José Pardo y Barreda <br> 1900
                                    </p>
                                </div>
                            </a>
                        </div>
                        <br>
                    </div>
                    <div class="col-sm-3 t1">
                        <div class="libro">
                            <a href="https://hdl.handle.net/20.500.14428/9990" target="_blank" style="color: black;">
                                <img src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_img007b.jpg" width="100%">
                                <div class="overlay3">
                                    <p class="fontMS500 text-center">
                                        Federico Elguera Seminario <br> 1886
                                    </p>
                                </div>
                            </a>
                        </div>
                        <br>
                        <div class="libro">
                            <a href="https://hdl.handle.net/20.500.14428/35837" target="_blank" style="color: black;">
                                <img src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_img007f.jpg" width="100%">
                                <div class="overlay3">
                                    <p class="fontMS500 text-center">
                                        Federico Elguera Seminario <br> 1901
                                    </p>
                                </div>
                            </a>
                        </div>
                        <br>
                    </div>
                    <div class="col-sm-3 t1">
                        <div class="libro">
                            <a href="https://hdl.handle.net/20.500.14428/55455" target="_blank" style="color: black;">
                                <img src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_img007c.jpg" width="100%">
                                <div class="overlay3">
                                    <p class="fontMS500 text-center">
                                        José Pardo y Barreda <br> 1899
                                    </p>
                                </div>
                            </a>
                        </div>
                        <br>
                        <div class="libro">
                            <a href="https://hdl.handle.net/20.500.14428/54387" target="_blank" style="color: black;">
                                <img src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_img007g.jpg" width="100%">
                                <div class="overlay3">
                                    <p class="fontMS500 text-center">
                                        José Pardo y Barreda <br> 1906
                                    </p>
                                </div>
                            </a>
                        </div>
                        <br>
                    </div>
                    <div class="col-sm-3 t1">
                        <div class="libro">
                            <a href="https://hdl.handle.net/20.500.14428/35834" target="_blank" style="color: black;">
                                <img src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_img007d.jpg" width="100%">
                                <div class="overlay3">
                                    <p class="fontMS500 text-center">
                                        Federico Elguera Seminario <br> 1890
                                    </p>
                                </div>
                            </a>
                        </div>
                        <br>
                        <div class="libro">
                            <a href="https://hdl.handle.net/20.500.14428/62961" target="_blank" style="color: black;">
                                <img src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_img007h.jpg" width="100%">
                                <div class="overlay3">
                                    <p class="fontMS500 text-center">
                                        Federico Elguera Seminario <br> 1906
                                    </p>
                                </div>
                            </a>
                        </div>
                        <br>
                    </div>
                </div>

                <!-- TABLET -->
                <div class="row menuTablet">
                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 libro t3">
                            <a href="https://hdl.handle.net/20.500.14428/16072" target="_blank" style="color: black;">
                                <img src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_img007a.jpg" width="100%">
                                <div class="overlay3">
                                    <p class="fontMS500 text-center">
                                        José Pardo y Barreda <br> 1887
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="col-sm-6 libro t3">
                            <a href="https://hdl.handle.net/20.500.14428/77952" target="_blank" style="color: black;">
                                <img src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_img007e.jpg" width="100%">
                                <div class="overlay3">
                                    <p class="fontMS500 text-center">
                                        José Pardo y Barreda <br> 1900
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 libro t3">
                            <a href="https://hdl.handle.net/20.500.14428/9990" target="_blank" style="color: black;">
                                <img src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_img007b.jpg" width="100%">
                                <div class="overlay3">
                                    <p class="fontMS500 text-center">
                                        Federico Elguera Seminario <br> 1886
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="col-sm-6 libro t3">
                            <a href="https://hdl.handle.net/20.500.14428/35837" target="_blank" style="color: black;">
                                <img src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_img007f.jpg" width="100%">
                                <div class="overlay3">
                                    <p class="fontMS500 text-center">
                                        Federico Elguera Seminario <br> 1901
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 libro t3">
                            <a href="https://hdl.handle.net/20.500.14428/55455" target="_blank" style="color: black;">
                                <img src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_img007c.jpg" width="100%">
                                <div class="overlay3">
                                    <p class="fontMS500 text-center">
                                        José Pardo y Barreda <br> 1899
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="col-sm-6 libro t3">
                            <a href="https://hdl.handle.net/20.500.14428/54387" target="_blank" style="color: black;">
                                <img src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_img007g.jpg" width="100%">
                                <div class="overlay3">
                                    <p class="fontMS500 text-center">
                                        José Pardo y Barreda <br> 1906
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                    <div class="row mt-3 mb-3">
                        <div class="col-sm-6 libro t3">
                            <a href="https://hdl.handle.net/20.500.14428/35834" target="_blank" style="color: black;">
                                <img src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_img007d.jpg" width="100%">
                                <div class="overlay3">
                                    <p class="fontMS500 text-center">
                                        Federico Elguera Seminario <br> 1890
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="col-sm-6 libro t3">
                            <a href="https://hdl.handle.net/20.500.14428/62961" target="_blank" style="color: black;">
                                <img src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_img007h.jpg" width="100%">
                                <div class="overlay3">
                                    <p class="fontMS500 text-center">
                                        Federico Elguera Seminario <br> 1906
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoVerde">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div style="margin-bottom: 5%;" class="row">
                    <div class="col-sm-4">
                        <p style="line-height: 100%;margin-bottom: 0%;" class="fontMS500 text-white font-70">
                            Espacio <br> de diálogo
                        </p>
                    </div>
                    <div class="col-sm-8">
                        <img id="img_dialogo" src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA_DIALOGO1.png">
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-4">
                        <img class="img-fluid mb-3" width="100%" src="\assets\images\micrositio\micrositio3\ET02_MS03_FOT_img008a.jpg">
                        <br>
                        <span class="fontMS100Italic text-white">
                            Retrato de Estevan Quispe, ca. 1899. <br>Colección Courret.
                        </span>
                    </div>
                    <div class="col-sm-8">
                        <p class="text-white fontMS500 font-24">
                            En 1935, cuando el estudio Courret cierra existían aproximadamente 150 mil placas fotográficas que fueron distribuidas como parte de pago entre los trabajadores. Posteriormente, 56 mil placas son vendidas a la Biblioteca Nacional del Perú. La historia
                            de nuestro país desde mediados del siglo XIX en adelante tiene rostro, aunque también tiene grandes ausencias. Entre todos los retratos fotográficos hasta ahora se ha podido documentar a un solo personaje llamado [Estevan Quispe],
                            quien lleva el apellido más extendido en el Perú de hoy: Quispe.
                        </p>
                    </div>
                    <div class="col-sm-4 mt-3">
                        <p class="text-white fontMS500 font-24">
                            ¿Qué grupos sociales no pudieron ser fotografiados en el siglo XIX? ¿Por qué motivos?
                        </p>
                        <img class="img_dialogoCol" src="\assets\images\general\DIALOGO_470.png">
                    </div>
                    <div class="col-sm-4">
                        <p class="text-white fontMS500 font-24">
                            ¿Cuáles son los más grandes cambios en la fotografía desde fines del siglo XIX hasta el presente?
                        </p>
                        <img class="img_dialogoCol" src="\assets\images\general\DIALOGO_470.png">
                    </div>
                    <div class="col-sm-4">
                        <p class="text-white fontMS500 font-24">
                            Observa y describe las fotografías. ¿Qué te comunican las que más te llamaron la atención?
                        </p>
                        <img class="img_dialogoCol" src="\assets\images\general\DIALOGO_470.png">
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-4">
                        <img class="LineSubsec_Izq" width="100%" src="\assets\images\micrositio\micrositio3\ET02_MS03_FOT__LINEA1-recortada2a.png">
                    </div>
                    <div class="col-sm-4">
                        <p style="line-height: 100%;margin-bottom: 0%;" class="fontMS700 text-center colorPrincipal font-38">
                            PARA SABER MÁS
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <img class="LineSubsec_Izq" width="100%" src="\assets\images\micrositio\micrositio3\ET02_MS03_FOT__LINEA1-recortada2a.png">
                    </div>
                </div>
                <p class="fontMS100 font-24">
                    <br> Recomendamos algunas de las fuentes consultadas durante la investigación.
                    <br><br>
                </p>
                <div class="row">
                    <div class="col-sm-6">
                        <p class="font-24">
                            <span class="fontMS500">
                                Babilonia, R. (2009).<br>
                            </span>
                            <span class="fontMS100Italic text-gris">
                                La guerra de nuestra memoria: crónica ilustrada de la Guerra del Pacífico,
                                1879-1884<br>
                            </span>
                            <span class="fontMS100">
                                Lima: Fondo Editorial del Pedagógico San Marcos - Fondo Editorial Universidad de
                                Ciencias y Humanidades.<br>
                            </span>
                            <a href="http://info.bnp.gob.pe:80/cgi-bin/abnopac?TITN=366488" target="_blank" style="color: black;">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        </p>
                        <!-- <p class="font-24">
                            <br>
                            <span class="fontMS500">
                                Camnitzer, L. y Montalbetti, M. (2019).
                            </span>
                            <br>
                            <span class="fontMS100Italic text-gris">
                                Montalbetti y Camnitzer. Ideas en torno a la fotografía contemporánea.
                            </span>
                            <br>
                            <span class="text-gris">
                                Lima: Meir Ramírez.
                            </span>
                            <br>
                            <a href="http://info.bnp.gob.pe:80/cgi-bin/abnopac?TITN=579865" target="_blank"
                                style="color: black;">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        </p> -->
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">
                                Deustua, J. y Schwarz, H. (2009).
                            </span>
                            <br>
                            <span class="fontMS100Italic text-gris">
                                Estudio Courret Hermanos, 1863-1935: la destrucción del olvido
                            </span>
                            <br>
                            <span class="text-gris">
                                Lima: Instituto Cultural Peruano Norteamericano.
                            </span>
                            <br>
                            <a href="http://info.bnp.gob.pe:80/cgi-bin/abnopac?TITN=375947" target="_blank" style="color: black;">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        </p>
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">
                                Natalia Majluf, N., Wuffarden, L. y Benavente, A. (2001).
                            </span>
                            <br>
                            <span class="fontMS100Italic text-gris">
                                La recuperación de la memoria. El primer siglo de la fotografía, Perú 1842-1942.
                            </span>
                            <br>
                            <span class="text-gris">
                                Lima: Fundación Telefónica - Museo de Arte de Lima.
                            </span>
                            <br>
                            <a href="http://info.bnp.gob.pe:80/cgi-bin/abnopac?TITN=267976" target="_blank" style="color: black;">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        </p>
                    </div>
                    <div class="col-sm-6">
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">
                                Schwarz, H. (2017).
                            </span>
                            <br>
                            <span class="fontMS100Italic text-gris">
                                Estudio Courret : historia de la fotografía en Lima
                            </span>
                            <br>
                            <span class="text-gris">
                                Lima: Municipalidad de Lima
                            </span>
                            <br>
                            <a href="https://publicacioneslima.pe/wp-content/uploads/2018/10/munilibro-12.pdf" target="_blank" style="color: black;">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        </p>
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">
                                Rojas Fox, W. (2017).
                            </span>
                            <br>
                            <span class="fontMS100Italic text-gris">
                                Un proyecto familiar oligárquico en el siglo XIX: la familia Garland de Lima
                            </span>
                            <br>
                            <span class="text-gris">
                                Lima: Universidad Nacional Mayor de San Marcos
                            </span>
                            <br>
                            <a href="https://cybertesis.unmsm.edu.pe/handle/20.500.12672/6107" target="_blank" style="color: black;">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        </p>
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">
                                Villacorta Chávez, J. y Trivelli, C. (2016).
                            </span>
                            <br>
                            <span class="fontMS100Italic text-gris">
                                Del daguerrotipo al selfie: una historia del retrato fotográfico peruano.
                            </span>
                            <br>
                            <span class="text-gris">
                                Lima: Instituto Cultural Peruano Norteamericano.
                            </span>
                            <br>
                            <a href="http://info.bnp.gob.pe:80/cgi-bin/abnopac?TITN=512103" target="_blank" style="color: black;">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- Footer -->